import { axiosRequestHandler } from '../../../helpers/apiHelper';

/**
 * Add dependencies tasks
 * @param {*} data
 * @param {Object[]} data.dependencies
 * * @param {Number} data.dependencies.source
 * * @param {Number} data.dependencies.target
 * * @param {fs|sf|ss|fs} data.dependencies.type
 * * @param {Number} data.dependencies.lag
 * @returns
 */
export const AddDependenciesAPI = async (data) => {
  try {
    return await axiosRequestHandler(`dependencies`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Sync dependency
 * @param {Object} requestParameters
 * @param {Number} requestParameters.id
 * @param {Number} data.dependencies.source
 * @param {Number} data.dependencies.target
 * @param {fs|sf|ss|fs} requestParameters.dependencies.type
 * @param {Number} requestParameters.dependencies.lag
 * @returns
 */
export const SyncDependenciesAPI = async (requestParameters) => {
  try {
    return await axiosRequestHandler(
      `tasks/${requestParameters.id}/dependencies/sync`,
      'POST',
      requestParameters
    );
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Update dependencies tasks
 * @param {*} data
 * @param {Object[]} data.dependencies
 * * @param {Object[]} data.dependencies.id
 * * @param {Number} data.dependencies.source
 * * @param {Number} data.dependencies.target
 * * @param {fs|sf|ss|fs} data.dependencies.type
 * * @param {String} data.dependencies.lag
 * @returns
 */
export const UpdateDependencyAPI = async (data) => {
  try {
    return await axiosRequestHandler(`dependencies/${data.id}`, 'patch', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Delete Dependency API
 * @param {String} id dependency Id
 * @returns
 */
export const DeleteDependencyAPI = async (data) => {
  try {
    return await axiosRequestHandler(`tasks/${data.taskId}/dependencies`, 'delete', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Bulk Update Dependency API
 * @param {Object[]} data
 * * @param {Object[]} Object.id
 * * @param {Number} Object.source
 * * @param {Number} Object.target
 * * @param {fs|sf|ss|fs} Object.type
 * * @param {String} Object.lag
 * @returns
 */
export const BulkUpdateDependencyAPI = async (data) => {
  try {
    return await axiosRequestHandler(`dependencies`, 'patch', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Bulk Delete Dependency API
 * @param {Object[]} data
 * * @param {Object[]} Object.id
 * * @param {Number} Object.source
 * * @param {Number} Object.target
 * * @param {fs|sf|ss|fs} Object.type
 * * @param {String} Object.lag
 * @returns
 */
export const BulkDeleteDependencyAPI = async (data) => {
  try {
    return await axiosRequestHandler(`dependencies`, 'delete', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};

/**
 * Bulk Upload Dependency API
 * @param {Object[]} data
 * * @param {Object[]} Object.id
 * * @param {Number} Object.source
 * * @param {Number} Object.target
 * * @param {fs|sf|ss|fs} Object.type
 * * @param {String} Object.lag
 * @returns
 */
export const BulkUploadDependencyAPI = async (data) => {
  try {
    return await axiosRequestHandler(`dependencies/bulk`, 'post', data);
  } catch (error) {
    throw new Error({ error: true, message: 'Something went wrong..!!' });
  }
};
